import styled from 'styled-components';
import DropdownProps from './type';

export const DropdownLabelStyled = styled.div<DropdownProps>`
  ${({ theme }) => theme.typography.bodyMedium3};
  margin-bottom: 9px;
  margin-top: 0px;
  p {
    margin: 0;
    padding: 0;
    color: ${({ theme }) => theme.colors.gray700};
  }
`;

export const DropdownWrapperStyled = styled.div<DropdownProps>`
  position: relative;
  width: ${({ fullWidth, desktopMode, width }) => {
    if (width) return width;
    if (desktopMode) return 'min-content';
    if (fullWidth) return '100%';
    return '325px';
  }};
`;

export const DropdownButtonStyled = styled.button<DropdownProps>`
  ${({ theme }) => theme.typography.bodyMedium3};
  padding-inline: 20px;
  overflow: hidden;
  white-space: nowrap;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 50px;
  width: 100%;
  background: #e3edf7;
  ${({ open, desktopMode }) => {
    if (desktopMode) return 'border-radius: 4px;';
    return open
      ? 'border-radius: 4px 4px 0px 0px;'
      : `border-radius: 4px;
        transition-duration: 0.25s;
        transition-delay: 0.5s;`;
  }};

  border: 1px solid #fff;
  box-shadow: ${({ open }) =>
    open
      ? '4px 4px 14px 0px #D9D9D9 inset, -4px -4px 9px 0px rgba(255, 255, 255, 0.88) inset;'
      : '4px 4px 20px 0px rgba(111, 140, 176, 0.41), -6px -6px 20px 0px #fff, 2px 2px 4px 0px rgba(114, 142, 171, 0.1);'};
  p {
    text-overflow: ellipsis;
    overflow: hidden;
    padding-right: 20px;
  }
`;

export const DropdownItemWrapperStyled = styled.div<DropdownProps>`
  overflow: scroll;
  width: 100%;
  transform-origin: top;
  ${({ open }) =>
    open ? 'transform: scaleY(1);  max-height: 570px;' : 'transform: scaleY(0);  max-height: 0px;'}
  transition-duration: 0.5s;
  button:nth-last-child(-n + 1) {
    border-radius: 0px 0px 4px 4px;
    border-bottom-color: #fff;
  }

  ${({ desktopMode }) => {
    if (desktopMode)
      return `
      border-radius: 4px;
      position: absolute;
      z-index: 1000;
      top: calc(100% + 20px);
      width: max(min-content, 100%);
      box-shadow: 4px 4px 20px 0px rgba(111, 140, 176, 0.41), -6px -6px 20px 0px #FFF, 2px 2px 4px 0px rgba(114, 142, 171, 0.10);
      button:nth-child(1) {
        border-radius: 4px 4px 0px 0px;
      }
      `;
    return '';
  }};
`;

export const DropdownItemStyled = styled.button<DropdownProps>`
  ${({ theme }) => theme.typography.body3};
  color: ${({ theme }) => theme.colors.gray700};
  text-align: start;
  padding-inline: 20px;
  background: #e3edf7;
  border: 1px solid #fff;
  border-top: 0px;
  overflow: hidden;
  white-space: nowrap;

  box-shadow: 4px 4px 14px 0px #d9d9d9 inset, -4px -4px 9px 0px rgba(255, 255, 255, 0.88) inset;
  p {
    text-overflow: ellipsis;
    overflow: hidden;
  }

  ${({ desktopMode }) => {
    if (desktopMode)
      return `
      background: #FFF;
      box-shadow: unset;
      border-bottom-color: #C6C8D2;
      `;
    return '';
  }};
`;
